<template>
  <div v-if="page_loading">
    <loading :page_loading="page_loading" />
  </div>
  <div v-else-if="detail != null">
    <loading :loading="loading" />

    <!-- นำทาง -->
    <v-card class="v-card-bottom-30">
      <v-card-title>
        {{ use_language.oms }}
        <v-icon>mdi-chevron-right</v-icon>
        <a @click="back()">{{ use_language.order_list }}</a>
        <v-icon>mdi-chevron-right</v-icon>
        {{ orderNo(detail.request) }}
        <v-chip small dark :color="statusColor[detail.request.status]" class="ml-3">{{ use_language[statusLabelKey(detail.request)] }}</v-chip>
        <v-spacer/>
        <!-- ผู้อนุมัติของชั้นที่คำขอรออยู่ -->
        <v-btn v-if="detail.canApprove" :elevation="1" color="success" class="px-2 mr-2" @click="Approve()">
          <v-icon size="20" class="mr-1">mdi-check-circle-outline</v-icon>
          {{ use_language.action_APPROVE }}
        </v-btn>
        <v-btn v-if="detail.canApprove" :elevation="1" color="red" dark class="px-2 mr-2" @click="rejectDialog = true">
          <v-icon size="20" class="mr-1">mdi-close-circle-outline</v-icon>
          {{ use_language.action_REJECT }}
        </v-btn>
        <v-btn v-if="detail.canEdit" :elevation="1" color="primary" class="px-2 mr-2" :to="'/oms/add-order?tempId=' + detail.request.tempID">
          <v-icon size="20" class="mr-1">fa-edit</v-icon>
          {{ use_language.edit_and_resubmit }}
        </v-btn>
        <v-btn v-if="detail.canCancel" :elevation="1" outlined color="red" class="px-2" @click="Cancel()">
          <v-icon size="20" class="mr-1">mdi-close-circle-outline</v-icon>
          {{ use_language.cancel_order_request }}
        </v-btn>
      </v-card-title>
    </v-card>

    <oms-reject-dialog
      v-model="rejectDialog"
      :temp-id="detail.request.tempID"
      :request-no="orderNo(detail.request)"
      @done="Load_data()"
    />

    <v-alert v-if="detail.request.status == 'APPROVED' && detail.request.orderMasterID" type="success" dense text class="v-card-bottom-30">
      {{ use_language.approved_order_created }} : <b>{{ orderIdText(detail.request.orderMasterID) }}</b>
    </v-alert>

    <v-alert v-if="detail.request.status == 'CANCELLED' && detail.request.orderMasterID" type="warning" dense text class="v-card-bottom-30">
      {{ use_language.status_ORDER_CANCELLED }} : <b>{{ orderIdText(detail.request.orderMasterID) }}</b>
    </v-alert>

    <v-alert v-if="detail.request.status == 'REJECTED' && detail.request.lastRejectReason" type="error" dense text class="v-card-bottom-30">
      <b>{{ use_language.reject_reason }} :</b> {{ detail.request.lastRejectReason }}
    </v-alert>

    <v-row>
      <v-col cols="12" md="7" class="py-0">
        <!-- ข้อมูลคำขอและร้านค้า -->
        <v-card elevation="1" class="v-card-bottom-30">
          <v-card-title class="height-57">
            <v-icon size="22" color="success darken-3">mdi-storefront</v-icon><span class="ml-3">{{ use_language.order_info }}</span>
          </v-card-title>
          <v-divider/>
          <v-card-text>
            <v-row v-for="row in infoRows" :key="row.label" class="py-1">
              <v-col cols="4" md="3" class="pa-0">{{ row.label }} :</v-col>
              <v-col cols="8" md="9" class="pa-0">{{ row.value }}</v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <!-- สินค้า -->
        <v-card elevation="1" class="v-card-bottom-30">
          <v-card-title class="height-57">
            <v-icon size="22" color="success darken-3">mdi-package-variant-closed</v-icon><span class="ml-3">{{ use_language.product }}</span>
            <v-spacer/>
            <span class="fn-14">{{ detail.request.itemCount }} {{ use_language.items }} / {{ formatMoney(String(detail.request.totalQuantity)) }} {{ use_language.pieces }}</span>
          </v-card-title>
          <v-divider/>
          <v-card-text>
            <v-data-table
              :headers="productHeader"
              :items="detail.items"
              :items-per-page="-1"
              hide-default-footer
              :no-data-text="use_language.no_data"
              class="packhai-border-table"
            >
              <template v-slot:item.no="{ item }">{{ detail.items.indexOf(item) + 1 }}</template>
              <template v-slot:item.photoLink="{ item }">
                <v-img v-if="item.photoLink" :src="item.photoLink" width="44" height="44" contain class="my-1 mx-auto"></v-img>
              </template>
              <template v-slot:item.productName="{ item }">
                <div>{{ item.productName }}</div>
                <div style="font-size: 12px; color: #9e9e9e;">{{ item.sku }}</div>
              </template>
              <template v-slot:item.quantity="{ item }"><b>{{ formatMoney(String(item.quantity)) }}</b></template>
              <template v-slot:item.availableQty="{ item }">{{ formatMoney(String(item.availableQty)) }}</template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" md="5" class="py-0">
        <!-- ประวัติการอนุมัติ -->
        <v-card elevation="1" class="v-card-bottom-30">
          <v-card-title class="height-57">
            <v-icon size="22" color="success darken-3">mdi-history</v-icon><span class="ml-3">{{ use_language.approval_history }}</span>
          </v-card-title>
          <v-divider/>
          <v-card-text>
            <v-timeline dense align-top>
              <v-timeline-item v-for="(item, index) in detail.history" :key="index" small :color="actionColor[item.action]">
                <div><b>{{ use_language['action_' + item.action] }}</b> <span v-if="(item.action == 'APPROVE' || item.action == 'REJECT') && item.level != 'AUTO'">({{ use_language['level_' + item.level] }})</span></div>
                <div style="font-size: 12px; color: #9e9e9e;"><span v-if="item.staffName">{{ item.staffName }} · </span>{{ formatOmsDatetime(item.createdAt) }} · {{ use_language.round }} {{ item.submitRound }}</div>
                <div v-if="item.reason" style="color: red;">{{ use_language.reject_reason }} : {{ item.reason }}</div>
              </v-timeline-item>
            </v-timeline>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import Swal from 'sweetalert2'
  import Loading from '@/website/components/Loading'
  import { formatMoney, format_order_id } from '@/website/global_function'
  import { getOmsLanguage } from '@/website/backend/oms/oms_language'
  import { OMS_STATUS_COLOR, formatOmsDatetime, orderNo, statusLabelKey } from '@/website/backend/oms/oms_status'
  import OmsRejectDialog from '@/website/backend/oms/components/OmsRejectDialog'
  import { getOrderRequestDetail, cancelOrderRequest, approveOrderRequest } from '@/website/backend/oms/oms_service'

  export default {
    components: {
      Loading,
      OmsRejectDialog
    },
    data: () => ({
      // page
      page_loading: true,
      loading: false,
      use_language: getOmsLanguage(),
      statusColor: OMS_STATUS_COLOR,
      actionColor: { SUBMIT: 'blue', RESUBMIT: 'blue', APPROVE: 'green', REJECT: 'red', CANCEL: 'grey', ORDER_CANCELLED: 'grey' },
      rejectDialog: false,
      detail: null
    }),
    computed: {
      infoRows () {
        const request = this.detail.request
        const store = this.detail.store || {}
        return [
          { label: this.use_language.request_no, value: orderNo(request) },
          { label: this.use_language.location, value: request.channel + ' : ' + request.locationName },
          { label: this.use_language.store, value: (request.storeName || '') + (request.storeCode ? ' (' + request.storeCode + ')' : '') },
          { label: this.use_language.contact, value: [store.contactName, store.phone].filter(text => !!text).join(' ') },
          { label: this.use_language.address, value: [store.address, store.subDistrict, store.district, store.province, store.postcode].filter(text => !!text).join(' ') },
          { label: this.use_language.created_by, value: request.createdByName },
          { label: this.use_language.submitted_at, value: formatOmsDatetime(request.submittedAt) + ' (' + this.use_language.round + ' ' + request.submitRound + ')' },
          { label: this.use_language.remark, value: this.detail.remark || '-' }
        ]
      },
      productHeader () {
        return [
          { text: this.use_language.no, align: 'center', value: 'no', sortable: false, width: '70px' },
          { text: '', align: 'center', value: 'photoLink', sortable: false, width: '70px' },
          { text: this.use_language.product, align: 'left', value: 'productName', sortable: false },
          { text: this.use_language.order_qty, align: 'right', value: 'quantity', sortable: false, width: '120px' },
          { text: this.use_language.available_qty, align: 'right', value: 'availableQty', sortable: false, width: '130px' }
        ]
      }
    },
    async created () {
      document.title = this.$router.history.current.meta.title
      await this.Load_data()
      this.page_loading = false
    },
    methods: {
      formatMoney,
      formatOmsDatetime,
      orderNo,
      statusLabelKey,
      showError (response) {
        this.$swal({
          position: 'top',
          type: 'error',
          text: response.message || (response.errorCode == 'NETWORK' ? this.use_language.network_error : this.use_language.cannot_perform_operation)
        })
      },
      back () {
        const status = this.detail != null ? this.detail.request.status : null
        this.$router.push('/oms/order' + (status != null ? '?status=' + status : ''))
      },
      async Load_data () {
        this.loading = true
        const response = await getOrderRequestDetail(Number(this.$route.query.id))
        this.loading = false
        if (response.status != 'success') {
          await this.$swal({ position: 'top', type: 'error', text: response.message || this.use_language.cannot_perform_operation })
          this.$router.replace('/oms/order')
          return
        }
        this.detail = response
      },
      // เลขออเดอร์จริงแบบเดียวกับที่ระบบแสดง เช่น PA0000123
      orderIdText (orderMasterId) {
        return format_order_id(orderMasterId)
      },
      Approve () {
        Swal.fire({
          type: 'question',
          title: orderNo(this.detail.request),
          text: this.detail.request.status == 'WAIT_ADMIN' ? this.use_language.confirm_approve_admin : this.use_language.confirm_approve_manager,
          confirmButtonText: this.use_language.action_APPROVE,
          cancelButtonText: this.use_language.close,
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          allowOutsideClick: false
        }).then(async (result) => {
          if (result.value) {
            this.loading = true
            const response = await approveOrderRequest([this.detail.request.tempID])
            this.loading = false
            const item = response.status == 'success' && response.results.length > 0 ? response.results[0] : response
            // โหลดใหม่ทั้งกรณีสำเร็จและไม่สำเร็จ เพราะสถานะอาจถูกคนอื่นเปลี่ยนไปแล้ว
            await this.Load_data()
            if (item.status != 'success') {
              this.showError(item)
              return
            }
            this.$swal({ toast: true, timer: 1500, showConfirmButton: false, position: 'top', type: 'success', title: this.use_language.success })
          }
        })
      },
      Cancel () {
        Swal.fire({
          type: 'question',
          title: orderNo(this.detail.request),
          text: this.use_language.confirm_cancel_order_request,
          confirmButtonText: this.use_language.confirm,
          cancelButtonText: this.use_language.close,
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          allowOutsideClick: false
        }).then(async (result) => {
          if (result.value) {
            this.loading = true
            const response = await cancelOrderRequest(this.detail.request.tempID)
            this.loading = false
            if (response.status != 'success') {
              this.showError(response)
              // สถานะอาจถูกเปลี่ยนโดยผู้อนุมัติไปแล้ว: โหลดใหม่ให้เห็นสถานะล่าสุด
              await this.Load_data()
              return
            }
            await this.Load_data()
            this.$swal({ toast: true, timer: 1500, showConfirmButton: false, position: 'top', type: 'success', title: this.use_language.success })
          }
        })
      }
    }
  }
</script>
